import React from 'react';
import { Outlet, useSearchParams } from 'react-router-dom';
import EmbedPageQueryParamProvider from './EmbedPageQueryParamProvider';
import {
  getAudioEnabled,
  getContext,
  getMargin,
  getTranscriptTimeRange,
} from './utils';

export interface EmbedPageQueryParamProviderRouteProps {}

const EmbedPageQueryParamProviderRoute: React.FC<
  EmbedPageQueryParamProviderRouteProps
> = () => {
  const [searchParams] = useSearchParams();

  return (
    <EmbedPageQueryParamProvider
      audioEnabled={getAudioEnabled(searchParams)}
      context={getContext(searchParams)}
      margin={getMargin(searchParams)}
      transcriptTimeRange={getTranscriptTimeRange(searchParams)}
    >
      <Outlet />
    </EmbedPageQueryParamProvider>
  );
};

export default EmbedPageQueryParamProviderRoute;
